import { BaseClient } from 'src/common-services/clients/base-client'
import { BrandDemographicsHistogramData } from 'src/common-services/types/alphamap'

export class BrandsDemographicsClient extends BaseClient {
  getBrandHHIncomeHistogram(id: string, miles: number): Promise<BrandDemographicsHistogramData> {
    return this.call<BrandDemographicsHistogramData>(`/v2/demographics/brands/${id}/histograms/hh-income`, 'POST', {
      data: { miles },
    })
  }

  getBrandHomeValueHistogram(id: string, miles: number): Promise<BrandDemographicsHistogramData> {
    return this.call<BrandDemographicsHistogramData>(`/v2/demographics/brands/${id}/histograms/home-value`, 'POST', {
      data: { miles },
    })
  }

  getBrandAgeHistogram(id: string, miles: number): Promise<BrandDemographicsHistogramData> {
    return this.call<BrandDemographicsHistogramData>(`/v2/demographics/brands/${id}/histograms/age`, 'POST', {
      data: { miles },
    })
  }

  getBrandTotalPopulationHistogram(id: string, miles: number): Promise<BrandDemographicsHistogramData> {
    return this.call<BrandDemographicsHistogramData>(
      `/v2/demographics/brands/${id}/histograms/total-population`,
      'POST',
      {
        data: { miles },
      }
    )
  }
}
